/* eslint-disable react/no-array-index-key */
import React, { memo } from "react"

import {Container} from './styles'
import InfoIcon from '../InfoIcon'

const RowTableMBA = ({ name, grade, showInfoIcon = false }) =>
  (
    <tr>
      <th className="">
        {name}
        {showInfoIcon && <InfoIcon />}
      </th>
      <th className="text-center">{grade}</th>
    </tr>
  )

  function isNumber(val){
    return typeof val === "number"
  }

const WeightsTableMBA = ({ data }) => {
  return (
    <Container>
       <div className="col-md-12">
        <h5 className="text-center">Notas das avaliações</h5>
        {data && isNumber(data.media) && (
          <div className="table-responsive">
            <table className="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>Avaliação</th>
                  <th className="text-center">Nota</th>
                </tr>
              </thead>
              <tbody>
                {data.assessments.map((item, index) => {
                  // Verifica se deve mostrar o ícone informativo
                  const shouldShowIcon = item.name && (
                    item.name.toLowerCase().includes('substitutiva') || 
                    item.name.toLowerCase().includes('suplementar')
                  );
                  
                  return (
                    <RowTableMBA 
                      key={index}
                      name={item.name} 
                      grade={item.grade && item.grade.toFixed(1)} 
                      showInfoIcon={shouldShowIcon}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
        )} 
      </div>
    </Container>
   
  )
}

export default memo(WeightsTableMBA)
